import { Box, styled, useTheme } from "@mui/material";

export const AgGridTableContainer = ({
  children,
  maxHeight,
}: {
  children: React.ReactNode;
  maxHeight?: string;
}) => {
  const theme = useTheme();

  return (
    <Container maxHeight={maxHeight}>
      <Box
        sx={{
          height: "100%",
          width: "100%",
          // Outer table border and rounding
          "& .ag-root-wrapper": {
            borderRadius: 0,
            border: "none",
            backgroundColor: theme.palette.background.default,
          },
          "& .ag-root": {
            // border: 'none',
          },
          // Row and cell grid lines
          "& .ag-header": {
            borderBottom: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.action.hover,
          },
          "& .ag-header-cell": {
            borderRight: `1px solid ${theme.palette.divider}`,
          },
          "& .ag-row": {
            borderBottom: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.default,
          },
          "& .ag-row .ag-cell": {
            borderRight: `1px solid ${theme.palette.divider}`,
          },
        }}
      >
        <div
          data-ag-theme-mode={theme.palette.mode}
          style={{
            height: "100%",
          }}
        >
          {children}
        </div>
      </Box>
    </Container>
  );
};

export const Container = styled(Box)({
  width: "100%",
  height: "100%",
  "@media (max-width: 768px)": {
    paddingBottom: "80px",
  },
});
